import Swiper, { Autoplay, Scrollbar, Mousewheel, Navigation, Pagination } from 'swiper/core';
// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
Swiper.use([ Autoplay, Scrollbar, Mousewheel, Navigation, Pagination]);
import 'swiper/scss';
import 'swiper/scss/scrollbar';
import 'swiper/scss/navigation';
import 'swiper/scss/pagination';

const initSwiper = (sliderContainer) => {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-call
  new Swiper(sliderContainer, {
    freeMode: {
      enabled: true,
      sticky: false,
    },
    slidesPerView: 'auto',
    mousewheel: {
      releaseOnEdges: true,
      forceToAxis: true,
    },
    spaceBetween: 0,
    watchSlidesVisibility: true,
    navigation: false,
    initialSlide: 0,
    scrollbar: {
      el: '.swiper-scrollbar',
      hide: false,
      draggable: true,
    },
  });
};

const initSwiperProduct = (sliderProductContainer) => {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-call
  new Swiper(sliderProductContainer, {
    lazy: true,
    slidesPerView: 1,
    mousewheel: {
      releaseOnEdges: true,
      forceToAxis: true,
    },
    spaceBetween: 0,
    initialSlide: 0,
    pagination: {
      el: '.swiper-pagination',
    },
    navigation: {
      prevEl: '.swiper-button-prev',
      nextEl: '.swiper-button-next',
    },  
  });
};


const initSwiperImageCarousel = (sliderimageCarouselContainer, autoplay, autoplayTime) => {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-call
  new Swiper(sliderimageCarouselContainer, {
    slideClass: 'wp-block-image',
    lazy: true,
    autoplay: autoplay ? { delay: autoplayTime, disableOnInteraction: false } : false,
    slidesPerView: 1,
    mousewheel: {
      releaseOnEdges: true,
      forceToAxis: true,
    },
    spaceBetween: 0,
    pagination: {
      el: '.swiper-pagination',
    },
    navigation: {
      prevEl: '.swiper-button-prev',
      nextEl: '.swiper-button-next',
    },  
  });
};

function initSliders() {
  const sliderContainers = document.querySelectorAll('.swiper');
  for (const sliderContainer of sliderContainers) {
    initSwiper(sliderContainer);
  }
  const sliderProductContainers = document.querySelectorAll('.swiper-product');
  for (const sliderProductContainer of sliderProductContainers) {
    initSwiperProduct(sliderProductContainer);
  }
  const sliderimageCarouselContainers = document.querySelectorAll('.swiper-image-carousel');
  for (const sliderimageCarouselContainer of sliderimageCarouselContainers) {
    const autoplay = sliderimageCarouselContainer.getAttribute('data-autoplay') === 'true';
    const autoplayTime = parseInt(sliderimageCarouselContainer.getAttribute('data-autoplay-time'));

    initSwiperImageCarousel(sliderimageCarouselContainer, autoplay, autoplayTime);
  }
}

if (document.readyState === 'complete') {
  initSliders();
} else {
  window.addEventListener('load', initSliders);
}
